// This is not currently used. We only have dev and test environments
// Reference: https://alaricsecurities.atlassian.net/wiki/spaces/1/pages/733708289/Environments

/**
 * Check for correct domain name (dev/test suffix) and port.
 *
 * For example for gateway:
 *    - on dev environment - gwdev.alaricsecurities.net:54072
 *    - on test environment - gwtest.alaricsecurities.net:54073
 */

const GATEWAY_ROOT = 'apigw-bff.acetrade.com/ace-portal';

const mainConfig = {
  baseURL: 'https://portal.acetrade.com',
  portalId: 1450, // AcePortal
  portalLang: 'en',
  auth: {
    issuer: 'https://auth.alaricsecurities.net',
    clientId: 'AcePortal',
    aceHubClientId: 'AceHub',
    loginRedirectUrl: 'https://portal.acetrade.com/auth-result',
    redirectUrlConfirmEmail: 'https://portal.acetrade.com/email-confirm',
    redirectUrlEmailConfirmed: 'https://portal.acetrade.com/email-confirmed',
    redirectUrlPhoneVerified: 'https://portal.acetrade.com/phone-verify',
    postLogoutRedirectUrl: 'https://portal.acetrade.com/authentication/login',
    redirectUrlProfileSecurity: 'https://portal.acetrade.com/funds',
    bffLoginUrl: `https://${GATEWAY_ROOT}/bff/login`,
    bffUserUrl: `https://${GATEWAY_ROOT}/bff/user`,
    bffLogoutUrl: `https://${GATEWAY_ROOT}/bff/logout`,
    bffRedeemSignupUrl: `https://${GATEWAY_ROOT}/bff/onboarding/redeem-signup`,
    // 1 - Alaric, 2 - Flb
    tenantId: 2000,
    scopes: [
      'roles',
      'TokenserverAPI.write',
      'TokenserverAPI.read',
      'tenant',
      'Alaric.FileStorage',
      'offline_access',
      'Alaric.Payment',
      'Alaric.Gateway',
      'Alaric.CRM',
      'IdentityServerApi',
      'phone',
      'two_factor_enabled',
      'Alaric.Audit',
      'Alaric.Subscription',
      'Alaric.Entitlement',
      'Alaric.Reporting',
      'platform',
      'Alaric.MarketData',
      'user_relation',
      'Alaric.News',
      'Alaric.Tapi',
      'Alaric.Fundamental',
      'openid',
      'profile',
      'email',
      'Alaric.MS',
      'Alaric.Administrative',
      'openid',
    ],
  },
  crm: {
    url: `https://${GATEWAY_ROOT}/customer`,
  },
  pwp: {
    url: 'https://alaric-pro.alaricsecurities.net/',
  },
  closeout: {
    url: `https://${GATEWAY_ROOT}/closeout`,
  },
  fundamental: {
    url: `https://${GATEWAY_ROOT}/fundamental`,
  },
  reporting: {
    url: `https://${GATEWAY_ROOT}/reporting`,
  },
  reportingFile: {
    url: `https://${GATEWAY_ROOT}/reporting`,
  },
  news: {
    url: `https://${GATEWAY_ROOT}/news/v1`,
  },
  file: {
    url: `https://${GATEWAY_ROOT}/file/v1`,
  },
  gateway: {
    url: GATEWAY_ROOT,
  },
  marketData: {
    url: 'ws://mds-lb.alaricsecurities.net:8001',
  },
  trading: {
    url: `wss://${GATEWAY_ROOT}/trading`,
  },
  payment: {
    url: `https://${GATEWAY_ROOT}/payment/v1`,
  },
  ams: {
    url: `https://${GATEWAY_ROOT}/message`,
  },
  cdn: {
    url: `https://${GATEWAY_ROOT}/content`,
  },
  currentEnv: 'prod',
  // Overrides the BFF flag environment when it cannot be derived from currentEnv - see
  // resolveFlagEnvironment. Only a UAT build needs it, the rest leave it null.
  flagEnvironment: null as string | null,
  dateFormat: 'LL',
  links: {
    privacyPolicyUrl: 'https://acetrade.com/privace-cookie-policy/',
    paymentTermsAndConditionsUrl: 'https://acetrade.com/terms-and-conditions/',
    helpCenterUrl: 'https://alaricsecurities.com/contact/#',
    selectedPlanRules: 'https://acetrade.com/funded.html',
    referralsLearnMoreUrl: 'https://acetrade.com/index.html',
    aceHubUrl: 'https://hub.acetrade.com/successful-sign-up',
    aceHelpCenterUrl: 'support@acetrade.com',
  },
};

/** Needed for tests */
export function changeEnv(env: any) { mainConfig.currentEnv = env; }

export default mainConfig;
